/* ============================================================
   AVESA - Upsell Popup Logic
   ============================================================
   מה הקובץ הזה עושה, בקצרה:
   1. "תופס" את הלחיצה על כפתור התשלום בעמוד העגלה (form submit).
   2. אם הוולידציה הקיימת של התקנון חוסמת את השליחה - הסקריפט
      הזה כלל לא מתערב (מכבד את הבדיקה הקיימת שלכם).
   3. אם התקנון תקין - בודק אילו מהמוצרים המוצעים עדיין
      לא נמצאים בעגלה.
   4. אם כל המוצרים כבר בעגלה - עובר ישר לתשלום, בלי פופאפ.
   5. אחרת - פותח פופאפ עם ההצעות שנשארו (רק פעם אחת בביקור).
   6. הוספה לעגלה מתוך הפופאפ מתבצעת דרך Shopify AJAX Cart API,
      בלי לצאת מהחלון ובלי לרענן את הדף.
   7. ברגע שהפופאפ נפתח - סימן שהתקנון כבר אושר (אחרת לא היינו
      מגיעים לכאן). לכן ההמשך לתשלום נעשה בניווט ישיר לעמוד
      /checkout, בלי "ללחוץ" שוב על כפתורים - כדי לא להתנגש
      עם ולידציות/סקריפטים נוספים שרצים על אותו כפתור.
   ============================================================ */

(function () {
  'use strict';

  var SESSION_KEY = 'avesaUpsellShown';
  var bypassNextSubmit = false;
  var productCache = {};
  var addedCount = 0;

  var overlay, modal, productsWrap, loadingEl, toastEl, closeBtn, skipBtn;
  var cartForm = null;

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    overlay = document.getElementById('avesa-upsell-overlay');
    if (!overlay) return;

    modal = overlay.querySelector('.avesa-upsell-modal');
    productsWrap = document.getElementById('avesa-upsell-products');
    loadingEl = document.getElementById('avesa-upsell-loading');
    toastEl = document.getElementById('avesa-upsell-toast');
    closeBtn = document.getElementById('avesa-upsell-close');
    skipBtn = document.getElementById('avesa-upsell-skip');

    cartForm = document.getElementById('cart');
    if (!cartForm) return;

    closeBtn.addEventListener('click', function () {
      closePopupAndProceed();
    });

    skipBtn.addEventListener('click', function () {
      closePopupAndProceed();
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopupAndProceed();
    });

    cartForm.addEventListener('submit', handleCartSubmit);

    preloadProductData();
  }

  function handleCartSubmit(e) {
    if (e.defaultPrevented) return;

    if (bypassNextSubmit) return;

    e.preventDefault();

    if (sessionStorage.getItem(SESSION_KEY) === '1') {
      proceedToCheckout();
      return;
    }

    addedCount = 0;

    getOfferHandlesNotInCart(function (offerHandles) {
      if (!offerHandles.length) {
        proceedToCheckout();
        return;
      }
      openPopup(offerHandles);
    });
  }

  function getOfferHandlesNotInCart(callback) {
    var allHandles = overlay.dataset.upsellHandles
      .split(',')
      .map(function (h) { return h.trim(); })
      .filter(Boolean);

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var handlesInCart = (cart.items || []).map(function (item) {
          return item.handle;
        });
        var remaining = allHandles.filter(function (h) {
          return handlesInCart.indexOf(h) === -1;
        });
        callback(remaining);
      })
      .catch(function () {
        proceedToCheckout();
      });
  }

  function preloadProductData() {
    var allHandles = overlay.dataset.upsellHandles
      .split(',')
      .map(function (h) { return h.trim(); })
      .filter(Boolean);

    allHandles.forEach(function (handle) {
      fetchProductData(handle);
    });
  }

  function fetchProductData(handle) {
    if (productCache[handle]) {
      return Promise.resolve(productCache[handle]);
    }
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('product not found: ' + handle);
        return res.json();
      })
      .then(function (product) {
        productCache[handle] = product;
        return product;
      })
      .catch(function () {
        return null;
      });
  }

  function openPopup(offerHandles) {
    renderLoading(true);
    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('avesa-upsell-lock');
    updateSkipButtonLabel();

    sessionStorage.setItem(SESSION_KEY, '1');

    Promise.all(offerHandles.map(fetchProductData)).then(function (products) {
      renderLoading(false);
      clearProductCards();

      var validProducts = products.filter(Boolean);

      if (!validProducts.length) {
        closePopupAndProceed();
        return;
      }

      validProducts.forEach(function (product) {
        productsWrap.appendChild(buildProductCard(product));
      });
    });
  }

  function renderLoading(isLoading) {
    loadingEl.style.display = isLoading ? 'flex' : 'none';
  }

  function clearProductCards() {
    var cards = productsWrap.querySelectorAll('.avesa-upsell-card');
    cards.forEach(function (card) { card.remove(); });
  }

  function buildProductCard(product) {
    var variant = product.variants[0];
    var card = document.createElement('div');
    card.className = 'avesa-upsell-card';
    card.dataset.handle = product.handle;

    var imageUrl = product.featured_image || (product.images && product.images[0]) || '';

    card.innerHTML =
      '<div class="avesa-upsell-card-image">' +
        (imageUrl ? '<img src="' + imageUrl + '" alt="" loading="lazy">' : '') +
      '</div>' +
      '<div class="avesa-upsell-card-info">' +
        '<p class="avesa-upsell-card-title">' + escapeHtml(product.title) + '</p>' +
        '<p class="avesa-upsell-card-price">' + formatMoney(variant.price) + '</p>' +
      '</div>' +
      '<button type="button" class="avesa-upsell-add-btn" data-variant-id="' + variant.id + '">' +
        '<span class="avesa-upsell-btn-text">הוסף לסל</span>' +
        '<span class="avesa-upsell-btn-spinner" aria-hidden="true"></span>' +
      '</button>';

    var addBtn = card.querySelector('.avesa-upsell-add-btn');
    addBtn.addEventListener('click', function () {
      addToCart(variant.id, addBtn, card);
    });

    return card;
  }

  function addToCart(variantId, buttonEl, cardEl) {
    if (buttonEl.classList.contains('is-loading') || buttonEl.classList.contains('is-done')) {
      return;
    }

    buttonEl.classList.add('is-loading');
    buttonEl.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add to cart failed');
        return res.json();
      })
      .then(function () {
        buttonEl.classList.remove('is-loading');
        buttonEl.classList.add('is-done');
        buttonEl.querySelector('.avesa-upsell-btn-text').textContent = '✓ נוסף';

        addedCount += 1;
        updateSkipButtonLabel();

        showToast('המוצר נוסף לעגלה בהצלחה');
        updateCartCountBubble();

        setTimeout(function () {
          cardEl.classList.add('is-removing');
          setTimeout(function () {
            cardEl.remove();
            if (!productsWrap.querySelector('.avesa-upsell-card')) {
              closePopupAndProceed();
            }
          }, 350);
        }, 700);
      })
      .catch(function () {
        buttonEl.classList.remove('is-loading');
        buttonEl.disabled = false;
        showToast('לא הצלחנו להוסיף, נסו שוב', true);
      });
  }

  function updateSkipButtonLabel() {
    skipBtn.textContent = addedCount > 0 ? 'המשך לתשלום ←' : 'לא תודה, המשך לתשלום ←';
  }

  var toastTimer = null;
  function showToast(message, isError) {
    toastEl.textContent = message;
    toastEl.style.background = isError ? '#a33f3f' : '';
    toastEl.classList.add('is-visible');

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2200);
  }

  function updateCartCountBubble() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
        bubbles.forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  function closePopupAndProceed() {
    overlay.classList.remove('is-active');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('avesa-upsell-lock');
    proceedToCheckout();
  }

  function proceedToCheckout() {
    window.location.href = '/checkout';
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'ILS';
    try {
      return new Intl.NumberFormat('he-IL', { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return amount + ' ' + currency;
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
})();